import alt from 'components/Dispatcher';
import {Store, StoreMethods} from '@store/@types/alt';
import NylasIntegrationActions, {
  NylasIntegrationActionsInterface,
} from '@store/nylas/NylasIntegrationActions';
import {NylasEnvironment, NylasState} from '@store/@types/nylas/NylasIntegration';
import {UserId} from 'records/User';

interface NylasIntegrationStoreState {
  // Global nylas settings for all accounts
  environment: NylasEnvironment | undefined;
  calendarEmail: string | undefined;
  // State of the session user's nylas connection
  nylasState: NylasState | undefined;
  nylasStateLoaded: boolean;
  nylasEnabled: boolean;
}

class NylasIntegrationStore
  extends Store<NylasIntegrationStoreState>
  implements StoreMethods<NylasIntegrationActionsInterface>
{
  constructor() {
    super();
    this.state = {
      calendarEmail: undefined,
      environment: undefined,
      nylasState: undefined,
      nylasStateLoaded: false,
      nylasEnabled: false,
    };
    this.bindActions(NylasIntegrationActions);
  }

  fetchCalendarEmail(): void {}
  fetchCalendarEmailError(error: Error): void {
    console.error(error);
  }
  fetchCalendarEmailSuccess(calendarEmail: string): void {
    this.setState({calendarEmail});
  }

  fetchHasNylasConnections(userIds: UserId[]): void {}
  fetchHasNylasConnectionsError(error: Error): void {
    console.error(error);
  }

  fetchNylasEnvironment(): void {}
  fetchNylasEnvironmentError(error: Error): void {
    console.error(error);
  }
  fetchNylasEnvironmentSuccess(environment: NylasEnvironment): void {
    this.setState({environment});
  }

  fetchNylasState(): void {
    this.setState({nylasStateLoaded: false});
  }
  fetchNylasStateError(error: Error): void {
    console.error(error);
  }
  fetchNylasStateSuccess(nylasState: NylasState | undefined): void {
    this.setState({
      nylasState,
      nylasEnabled: nylasState === NylasState.RUNNING,
      nylasStateLoaded: true,
    });
  }

  forgetNylasConnection(): void {}
  forgetNylasConnectionError(error: Error): void {
    console.error(error);
  }
  forgetNylasConnectionSuccess(): void {
    this.setState({
      nylasEnabled: false,
      nylasState: undefined,
      nylasStateLoaded: false,
      calendarEmail: undefined,
    });
  }
}

export default alt.createStore(NylasIntegrationStore);
